import {requestTypes} from "@shared/constants/request.constants";

const requestDiscriminationValues = {
  [requestTypes.AMBULANCE_REQUEST]: 'schedule_ambulance',
  [requestTypes.TELEPHONE_CONTACT_REQUEST]: 'call_me',
  [requestTypes.SUGGESTIONS_REQUEST]: 'suggestion',
  [requestTypes.APPOINTMENT_REQUEST]: 'appointment_create',
  [requestTypes.APPOINTMENT_CHANGE_REQUEST]: 'appointment_change',
  [requestTypes.PROFILE_UPDATE_REQUEST]: 'profile_update'
}

const requestTypeOrigins = {
  MEDICAL_REQUEST: 'MEDICAL_REQUEST',
  PENDING_MEDICAL_REQUEST: 'PENDING_MEDICAL_REQUEST'
};

const requestStates = {
  ALL: 'ALL',
  PENDING: 'PENDING',
  DONE: 'DONE'
};

const radioStudioTypeCodes = {
  STUDY_WITH_REPORT: 'STUDY_WITH_REPORT',
  STUDY_WITHOUT_REPORT: 'STUDY_WITHOUT_REPORT',
  TELERADIOLOGY: 'TELERADIOLOGY'
};

export {
  requestDiscriminationValues,
  requestTypeOrigins,
  requestStates,
  radioStudioTypeCodes
};
